import {RootState} from '..';

export const selectMyProfileId = (state: RootState) => state.myProfile?.data?.id || '';
export const selectMyProfileUserPrincipalName = (state: RootState) =>
    state.myProfile?.data?.userPrincipalName || '';
